export const environment = {
  "version": "2.9.6",
  "revision": "1af9e54",
  "production": true,
  "beta": false,
  "canary": false,
  "apiKey": "c96ee48b28f94bf38f8baff4e27730d7",
  "clientId": "51176",
  "client_secret": "N7XUjcK8qRGNBF47zXsas0Vt-ObmNNvZMfWVhv7eJ1s",
  "offlineMode": false,
  "highlight_project_id": "2d1yrx4d",
  "featureFlags": {
    "enableModslotLimitation": true,
    "enableZeroWaste": true,
    "enableGuardianGamesFeatures": true
  }
};